import React from 'react'
import { compose, withState, lifecycle } from 'recompose'
import Container from 'components/Container'
import CmsApis from 'apis/cmsApis'
import Paper from 'material-ui/Paper'
import { Grid, Input, Button } from 'semantic-ui-react'
import Scroll from 'react-scroll'
import StateToolBar from 'components/bars/StateToolBar'
import FormImageCarousel from 'components/forms/image/FormImageCarousel'
import MagentoCategories from 'components/magento/MagentoCategories';
import { updateObject } from 'helpers/objectHelpers'
import withEditPage from 'hocs/extends/withEditPage'
import FormLevelCBanner from 'components/forms/FormLevelCBanner'
import CategoryAddDialog from './CategoryAddDialog'

const scroll = Scroll.animateScroll

const CategoryBannerController = compose(
  withState('adding', 'onChangeAdding', false),
)(
  ({
    categoryBanner,
    categoryBanner: {
      data,
      categoryName,
    },
    params: {
      id,
    },
    adding,
    onChangeAdding,
    selectedCategory,
    onUpdateSelectedCategory,
    onChange,
    onSave,
    saveStatus,
    isStateChanged,
    setIsStateChanged,
    onDiscardChange,
  }) => {
    if (!data) {
      return null
    }
    const handleCategoryUpdate = (categoryBanner) => {
      setIsStateChanged(true)
      return onChange(categoryBanner)
    }
    const handleDataUpdate = (val) => {
      return handleCategoryUpdate(updateObject(categoryBanner, { data: val }))
    }
    const handleCategoryDetailUpdate = (val) => {
      return handleCategoryUpdate(updateObject(categoryBanner, val))
    }
    return (
      <div>
        <Container>
          <Paper>
            <StateToolBar
              primary={isStateChanged}
              isStateChanged={isStateChanged}
              onDiscard={() => {
                setIsStateChanged(false)
                return onDiscardChange()
              }}
              onSave={onSave}
              saveStatus={saveStatus}
            />
            <Grid columns={3} centered>
              <Grid.Column width={6}>
                <div style={{ paddingTop: 10, display: 'flex', verticalAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginRight: 10 }}>
                    <b>Category : </b>
                  </div>
                  <Input style={{ marginRight: 10 }} disabled value={categoryName} />
                  { !id &&
                    <Button onClick={() => onChangeAdding(!adding)}>Select</Button>
                  }
                </div>
              </Grid.Column>
            </Grid>
            <Grid columns={3} centered>
              <Grid.Column width={6}>
                <FormLevelCBanner
                  value={data}
                  onChange={handleDataUpdate}
                />
              </Grid.Column>
            </Grid>
            <CategoryAddDialog
              open={adding}
              onClose={() => { onChangeAdding(false) }}
              updateCategory={(cat) => {
                scroll.scrollToBottom({ delay: 0, duration: 300, smooth: true })
                handleCategoryDetailUpdate(cat)
                onChangeAdding(!adding)
              }}
            />
          </Paper>
        </Container>
      </div>
    )
  },
)

CategoryBannerController.propTypes = {}
CategoryBannerController.defaultProps = {}

export default CategoryBannerController



// WEBPACK FOOTER //
// ./src/pages/Banners/children/CategoryBanners/CategoryBannerController.js